import { Card } from "react-bulma-components";
import UilLogin from "@iconscout/react-unicons/icons/uil-signin";
import { LOGIN_EMAIL_QUERY_STRING_PARAM } from "utils/constants";
import useUserInfo from "hooks/useUserInfo";
import { Box, H3, LinkButton, Stack } from "@adfenix/alexandria";
import { useTranslation } from "react-i18next";

export const LoginCard = () => {
  const { t } = useTranslation();
  const { userEmail, tokenSource } = useUserInfo();

  if (tokenSource !== "ADFENIX") return null;

  return (
    <Card>
      <Stack pY={"xl4"} pX={"xl4"} spacing={"gutter"}>
        <Box display="flex" justifyContent="center">
          <UilLogin size="48px" />
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <H3 style={{ textAlign: "center" }}>
            {t("listing_page_login_card_title")}
          </H3>
        </Box>
        <Box display="flex" justifyContent="center">
          <LinkButton
            logLabel="listings-login-link"
            to={`/login?${LOGIN_EMAIL_QUERY_STRING_PARAM}=${encodeURIComponent(
              userEmail
            )}`}
          >
            {t("login.card.loginButton")}
          </LinkButton>
        </Box>
      </Stack>
    </Card>
  );
};
